import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faRotateRight } from "@fortawesome/free-solid-svg-icons";
import {
  formatDate,
  formatAmountForDisplay,
  paymentStatusBadgeClass,
  fulfillmentStatusBadgeClass,
} from "./examUtils";

const ExamPurchaseTable = ({
  purchases,
  isReloading,
  sort,
  onSortChange,
  onView,
  onRetry,
  retryLoadingId,
}) => {
  return (
    <table className="table table-sm table-hover mb-0 align-middle exam-table-compact">
      <thead>
        <tr>
          <th>Reference</th>
          <th>Customer</th>
          <th
            style={{ cursor: "pointer" }}
            onClick={() => onSortChange(sort === "-amount" ? "amount" : "-amount")}
          >
            Amount (₦)
          </th>
          <th>Payment</th>
          <th style={{ minWidth: "130px" }}>Fulfillment</th>
          <th
            style={{ cursor: "pointer", minWidth: "150px" }}
            onClick={() => onSortChange(sort === "newest" ? "oldest" : "newest")}
          >
            Date
          </th>
          <th style={{ minWidth: "120px" }}>Actions</th>
        </tr>
      </thead>
      <tbody>
        {isReloading && (
          <tr>
            <td colSpan={7}>
              <div className="d-flex justify-content-center align-items-center tableLoader">
                <div className="loader"></div>
              </div>
            </td>
          </tr>
        )}
        {!isReloading && purchases.length === 0 && (
          <tr>
            <td colSpan={7}>
              <div className="d-flex justify-content-center align-items-center tableLoader">
                No purchases to display
              </div>
            </td>
          </tr>
        )}

        {purchases.map((p) => (
          <tr key={p.id}>
            <td className="text-start">{p.reference || "--"}</td>
            <td>
              <div className="text-[13px] font-semibold leading-tight text-slate-800">
                {p.customerName || p.name || "—"}
              </div>
              <div className="truncate text-[11px] leading-tight text-slate-500">
                {p.customerEmail}
              </div>
            </td>
            <td>₦{formatAmountForDisplay(p.amount)}</td>
            <td>
              <span className={paymentStatusBadgeClass(p.paymentStatus)}>
                {p.paymentStatus}
              </span>
            </td>
            <td>
              <span className={fulfillmentStatusBadgeClass(p.fulfillmentStatus)}>
                {p.fulfillmentStatus}
              </span>
            </td>
            <td>{formatDate(p.createdAt)}</td>
            <td>
              <div className="d-flex gap-1">
                <button
                  title="View"
                  className="btn btn-outline-secondary btn-sm"
                  onClick={() => onView(p)}
                >
                  <FontAwesomeIcon icon={faEye} />
                </button>
                <button
                  title={
                    p.fulfillmentStatus === "INVENTORY_SHORTAGE"
                      ? "Retry fulfillment"
                      : "Only purchases awaiting inventory can be retried"
                  }
                  className="btn btn-outline-primary btn-sm"
                  disabled={
                    retryLoadingId === p.id || p.fulfillmentStatus !== "INVENTORY_SHORTAGE"
                  }
                  onClick={() => onRetry(p)}
                >
                  <FontAwesomeIcon
                    icon={faRotateRight}
                    className={retryLoadingId === p.id ? "fa-spin" : ""}
                  />
                </button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ExamPurchaseTable;